import fetchSQS from "./fetchSQS";

export default async function serviceQuery(serviceMessageObject) {
   return fetchSQS("servicequery/" + serviceMessageObject.message, "POST", {
      query: serviceMessageObject.query,
   });
}
